(function () {
    angular.module('tradersyard').component('tyReportSuccessModal', {
        // language=HTML
        template: `
            <div class="modal-header">
                <h5 class="modal-title">Your report was sent successfully</h5>
            </div>
            <div class="modal-body">
                <a class="button" ng-click="$ctrl.close()">Close</a>
            </div>
        `,
        bindings: {
            close: '&',
        },
    });
})();
